// Kite Free Gift Vendor Display Enhancement
(function() {
  'use strict';


  // Cache for vendor data
  const vendorCache = new Map();

  // Fetch vendor for a product
  async function fetchVendor(productId) {
    if (vendorCache.has(productId)) {
      return vendorCache.get(productId);
    }

    try {
      // First get the product handle from search
      const searchResponse = await fetch(`${window.Shopify.routes.root}search/suggest.json?q=id:${productId}&resources[type]=product&limit=1`);
      const searchData = await searchResponse.json();

      if (searchData.resources?.results?.products?.[0]) {
        const handle = searchData.resources.results.products[0].handle;

        // Then fetch full product data to get vendor
        const productResponse = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
        const productData = await productResponse.json();

        const vendor = productData.vendor || '';
        vendorCache.set(productId, vendor);
        return vendor;
      }
    } catch (e) {
    }

    return null;
  }

  // Insert vendor below title
  function insertVendor(row, vendor) {
    if (!vendor) return;

    // Check if vendor already exists
    if (row.querySelector('.gfg-vendor-info')) {
      return;
    }

    const titleElement = row.querySelector('.gfgFreeGiftMsgTitle');
    if (!titleElement) {
      return;
    }

    const vendorEl = document.createElement('div');
    vendorEl.className = 'gfg-vendor-info';
    vendorEl.textContent = vendor;
    vendorEl.style.cssText = 'color: black; font-size: 12px; font-weight: 400; margin-top: 2px; text-transform: uppercase; letter-spacing: 0.5px;';

    // Insert after the title
    if (titleElement.nextSibling) {
      titleElement.parentNode.insertBefore(vendorEl, titleElement.nextSibling);
    } else {
      titleElement.parentNode.appendChild(vendorEl);
    }

  }

  // Process all gift rows
  async function processGifts() {
    const rows = document.querySelectorAll('.gfgFreeGiftMsgOptionRow[product-id]');

    if (rows.length === 0) {
      return;
    }

    // Build list of products to fetch
    const toFetch = new Set();
    const rowMap = new Map();

    for (const row of rows) {
      // Skip if vendor already added
      if (row.querySelector('.gfg-vendor-info')) continue;

      const productId = row.getAttribute('product-id');
      if (!productId) continue;

      if (!rowMap.has(productId)) {
        rowMap.set(productId, []);
      }
      rowMap.get(productId).push(row);

      if (!vendorCache.has(productId)) {
        toFetch.add(productId);
      }
    }


    // Fetch all vendors in parallel
    if (toFetch.size > 0) {
      await Promise.all(Array.from(toFetch).map(id => fetchVendor(id)));
    }

    // Apply vendors to rows
    for (const [productId, rowList] of rowMap) {
      const vendor = vendorCache.get(productId);
      if (vendor) {
        rowList.forEach(row => insertVendor(row, vendor));
      }
    }
  }

  // Main function to watch for Kite app
  function watchForKite() {

    // Process function with retry
    const tryProcess = () => {
      const container = document.querySelector('.gfgFreeGiftOptionsContainerDiv');
      if (container) {
        // Wait a bit for Kite to finish rendering
        setTimeout(() => {
          processGifts().then(() => {
            // Check again after a short delay in case Kite re-renders
            setTimeout(() => {
              const rows = document.querySelectorAll('.gfgFreeGiftMsgOptionRow[product-id]:not(:has(.gfg-vendor-info))');
              if (rows.length > 0) {
                processGifts();
              }
            }, 500);
          });
        }, 200);
      }
    };

    // Initial check
    tryProcess();

    // Watch for DOM changes
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;

      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
              // Check if it's a Kite container or contains one
              if (node.classList?.contains('gfgFreeGiftOptionsContainerDiv') ||
                  node.querySelector?.('.gfgFreeGiftOptionsContainerDiv') ||
                  node.classList?.contains('gfgFreeGiftMsgOptionRow')) {
                shouldProcess = true;
                break;
              }
            }
          }
          // Also check if gift rows were modified
          if (mutation.target.classList?.contains('gfgFreeGiftOptionsContainerDiv')) {
            shouldProcess = true;
          }
        }
      }

      if (shouldProcess) {
        setTimeout(tryProcess, 300);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Periodic check for first 5 seconds
    let checks = 0;
    const interval = setInterval(() => {
      checks++;
      if (checks > 20) {
        clearInterval(interval);
        return;
      }
      tryProcess();
    }, 250);
  }

  // Initialize when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForKite);
  } else {
    watchForKite();
  }
})();